export default __webpack_public_path__ + "static/media/debt_interest_incurred_blue.f6a322a7.svg";